<template>
    <div class="md:tw-inline-block tw-relative">

        <button id="actionsMenuHRButton" @click="isDropdownOpen = ! isDropdownOpen" class="cu-btn tw-relative tw-mb-1">Aktion
            <i class="fa fa-chevron-down tw-ml-1"></i>
        </button>

        <div id="myDropdown" style="min-width: 250px;"
             class="dropdown-content tw-bg-white tw-absolute tw-overflow-auto tw-z-20 tw-rounded-md tw-pt-2 tw-pb-2 tw-border tw-border-navbar-secondary tw-right-0"
             v-show="isDropdownOpen"
             v-closable="{
                exclude: ['#actionsMenuHRButton'],
                handler: 'onClose'
            }"
        >
            <button type="button"
                    class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                    data-toggle="modal" data-target="#edit-mail"
            >
                <span>Bearbeiten</span>
            </button>

            <hr class="tw-my-2 tw-mr-0 tw-ml-0">

            <div class="tw-flex tw-flex-wrap">
                <template v-if="[MailStatus.STATUS_USER_INVITED_PROBE, MailStatus.STATUS_USER_INVITED_INTERN].indexOf(mail.status) !== -1">
                    <a :href="`/application/${mail.id}/hr/probe-contract-done`" class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black" aria-label="Left Align">
                        erledigt
                    </a>
                </template>
                <template v-if="[MailStatus.STATUS_CONTRACT].indexOf(mail.status) !== -1">
                    <a :href="`/application/${mail.id}/reject-hr`" class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black" aria-label="Left Align">
                        abgelehnt
                    </a>

                    <a :href="`/application/${mail.id}/hire`" class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black" aria-label="Left Align">
                        eingestellt
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Radio from "../Radio";
    import CheckBox from "../CheckBox";
    import BorderedInput from "../BorderedInput";

    const MailStatus = {
        STATUS_UNREAD: 1,
        STATUS_READ: 2,
        STATUS_TELKO: 3,
        STATUS_TALK: 4,
        STATUS_PROBE: 5,
        STATUS_HOLD: 6,
        STATUS_CONTRACT: 7,
        STATUS_EMPLOYED: 8,
        STATUS_DENIED: 9,
        STATUS_USER_REJECTED: 10,
        STATUS_USER_INVITED_TELKO: 11,
        STATUS_USER_INVITED_TALK: 12,
        STATUS_USER_INVITED_PROBE: 13,
        STATUS_USER_INVITED_INTERN: 25,
        STATUS_DENIED_AFTER_APPOINTMENT: 14,
        STATUS_DENIED_CONTRACT: 15,
        STATUS_HIRED: 16,
        STATUS_AUTOMATIC_DENIED: 17,
        STATUS_AUTOMATIC_DENIED_NOT_REACHED: 18,
        STATUS_AUTOMATIC_REFUSED: 19,
        STATUS_USER_INVITED_PROBE_AND_HR_MADE_PROBE_CONTRACT: 20,
        STATUS_FAILED_TO_APPEAR: 27,
    };

    const MailDepartmentStatus = {
        STATUS_UNREAD: 'unread',
        STATUS_READ: 'read',
        STATUS_DENIED: 'denied',
        STATUS_INVITE_PHONE: 'invite phone',
        STATUS_INVITE_INTERVIEW: 'invite interview',
        STATUS_INVITE_TRIAL_WORK: 'invite trial work',
        STATUS_REINVITE_PHONE: 'reinvite phone',
        STATUS_REINVITE_INTERVIEW: 'reinvite interview',
        STATUS_REINVITE_TRIAL_WORK: 'reinvite trial work',
        STATUS_USER_REJECTED: 'user rejected',
        STATUS_INVITED_PHONE: 'invited phone',
        STATUS_INVITED_INTERVIEW: 'invited interview',
        STATUS_INVITED_TRIAL_WORK: 'invited trial work',
        STATUS_REINVITED_PHONE: 'reinvited phone',
        STATUS_REINVITED_INTERVIEW: 'reinvited interview',
        STATUS_REINVITED_TRIAL_WORK: 'reinvited trial work',
        STATUS_DENIED_AFTER_APPOINTMENT: 'denied after appointment',
        STATUS_HOLD: 'hold',
        STATUS_CONTRACT: 'contract',
        STATUS_DENIED_CONTRACT: 'denied contract',
        STATUS_HIRED: 'hired',
        STATUS_AUTOMATIC_DENIED: 'auto denied',
        STATUS_AUTOMATIC_DENIED_NOT_REACHED: 'not reached auto denied',
        STATUS_AUTOMATIC_REFUSED: 'auto refused',
        STATUS_FAILED_TO_APPEAR: 'failed to appear',
    };

    export default {
        components: {
            Radio,
            CheckBox,
            BorderedInput,
        },

        props: {
            mail: {
                required: true,
                type: Object,
            },
            department: {
                required: false,
                type: Object,
                default: null,
            },
        },

        data() {
            return {
                isDropdownOpen: false,
                csrfToken: null,
                MailStatus: MailStatus,
                MailDepartmentStatus: MailDepartmentStatus,

                validationErrors: {},
            }
        },

        methods: {
            onClose() {
                this.isDropdownOpen = false;
            },
        },

        mounted() {
            this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
        }
    }
</script>